/*
 * 功能名称: 技能字典
 * 创 建 人: 程天乐
 * 日    期: 2024-02-29 10:50:39
 */
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";

export class PerformanceIndicatorApi extends NewviewOaBaseApi {

    public get ControllerName(): any {
        return 'performance-indicator';
    } 
    constructor() {
        super();
        this.addHeader("tableName", 'performance_indicator');
    } 
    
}